namespace Rio.Enums {
    export enum EDeviceRestrictionType {
        Unlimited = 0,
        Limited = 1,
        Single = 2
    }
    Serenity.Decorators.registerEnumType(EDeviceRestrictionType, 'Rio.Enums.EDeviceRestrictionType');
}
